import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, type NavigateOptions } from 'react-router';

import { getLocaleUrl, getValidLocale } from '@/shared/utils/i18n.utils';
import { formatPrice } from '@/shared/utils/number.utils';

export const useNavigateWithLocale = () => {
  const params = useParams();
  const navigate = useNavigate();

  const navigateWithLocale = useCallback(
    (path: string, options?: NavigateOptions) => {
      const currentLocale = getValidLocale(params.locale);
      const localizedPath = getLocaleUrl(currentLocale, path);
      navigate(localizedPath, options);
    },
    [params, navigate],
  );

  return navigateWithLocale;
};

export const useLocaleFormatPrice = () => {
  const { i18n } = useTranslation();
  const currentLocale = getValidLocale(i18n.language);
  return useCallback(
    (price: number | null | undefined) => formatPrice(price, currentLocale),
    [currentLocale],
  );
};
